import React from 'react';
import Widgets from './Widgets';
import { Form } from 'antd';
import { ISchemaEditorProperties } from '@src/controls/editors/SchemaEditor';
import { getLang } from '@src/packages/pro-table/component/util';

const Base: React.FC<{
  itemId?: number | string | null;
  data?: any;
  schema: ISchemaEditorProperties;
  disabled?: boolean;
  invalid?: boolean;
  value?: any;
  onChange?: (val: any) => void;
  labelCol?: Record<string, any>;
  wrapperCol?: Record<string, any>;
}> = (props) => {
  const locale = getLang();
  const currentLocale = locale.split('-')[0];
  const { labelCol, wrapperCol } = props;
  const schemaName =
    currentLocale === 'la'
      ? props.schema.nameLa || props.schema.name
      : currentLocale === 'en'
        ? props.schema.nameEn || props.schema.name
        : props.schema.name;
  const error = () => {
    // const errorMessage =
    //   currentLocale === 'la'
    //     ? `${props.schema.nameLa} ກະລຸນາປ້ອນຂໍ້ມູນ!`
    //     : currentLocale === 'en'
    //       ? `${props.schema.nameEn} cannot be empty!`
    //       : `${schemaName} không được để trống!`;
    const errorMessage =
      currentLocale === 'la'
        ? `ກະລຸນາປ້ອນຂໍ້ມູນ!`
        : currentLocale === 'en'
          ? `Cannot be empty!`
          : `Không được để trống!`;
    return errorMessage;
  };
  const layoutFormItem = React.useMemo(() => {
    if (labelCol && wrapperCol) {
      return {
        labelCol,
        wrapperCol,
      };
    }
    return {};
  }, [labelCol, wrapperCol]);

  const Widget = Widgets[props.schema.widget];
  if (!Widget) {
    return <p>Invalid type {props.schema.widget}</p>;
  }
  return (
    <Form.Item
      name={props.schema.field}
      label={schemaName}
      rules={[{ required: props.schema.required, message: error() }]}
      extra={
        <span className='gx-text-light gx-font-weight-light gx-fs-sm gx-font-italic'>
          {currentLocale === 'la'
            ? props.schema.introLa
            : currentLocale === 'en'
              ? props.schema.introEn
              : props.schema.intro}
        </span>
      }
      {...layoutFormItem}
    >
      <Widget
        // onChange={props.onChange}
        // value={props.value === undefined ? props.schema.default : props.value}
        schema={props.schema}
        disabled={props.schema.disabled}
        dataForm={props.data}
      // invalid={this.isInvalid()}
      />
    </Form.Item>
  );
};

export default React.memo(Base);
